import React from 'react';

import CommonNode from '../../../../components/node/common-node';
import { NodeProvider } from '../../../../context/node-context';
import { getNodeName } from '../../../../utils/getNodeName';
import DirectoryListTaskForm from './forms/directory-list-task-form';
import { directoryListTaskValidationSchema } from './schema.js';

export default function SftpOperationDirectoryListNode({ data, id, type }) {
  const nodeName = getNodeName(data?.name, 'SFTP Operation Directory Listing Task');

  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: nodeName,
        altText: 'SFTP Operation Directory Listing Task',
        defaultLabel: 'SFTP Operation Directory Listing Task',
      }}
    >
      <CommonNode
        FormComponent={DirectoryListTaskForm}
        schemaResolver={directoryListTaskValidationSchema}
      />
    </NodeProvider>
  );
}
